
// multi-highlighted
(function () {
    var $element = $('.multi-highlighted-content');
    if ($element && $element.length && !$element.closest('.creative-banner').length) {
        $element.each(function () {
            var scrollController = new ScrollMagic.Controller();
            var timeline = new TimelineLite();

            $(this).find('.highlighted-content').each(function (index) {
                var content = $(this);
                var arrow = content.find('img');
                var title = content.find('h5 span');
                var description = content.find('p');
                timeline.fromTo(arrow, 1, { x: -100, y: 100, scale: 0 }, { x: 0, y: 0, opacity: 1, scale: 1, ease: Power3.easeInOut }, index === 0 ? '0' : '-=1')
                    .fromTo(title, 0.5, { x: -(title.width()) }, { x: 0, opacity: 1, ease: Power4.easeInOut }, '-=0.25')
                    .fromTo(description, 0.5, { x: -(description.width()) }, { x: 0, opacity: 1, ease: Power4.easeInOut }, '-=0.25');
            });

            new ScrollMagic.Scene({
                offset: $(this).offset().top / 4,
                reverse: false
            })
                .setTween(timeline)
                .addTo(scrollController);
        });
    }
})();


// colored icon links
(function () {
    var $element = $('.colored-icon-links');
    if ($element && $element.length) {
        $element.each(function () {
            var scrollController = new ScrollMagic.Controller();
            var timeline = new TimelineLite();

            $(this).find('a').each(function (index) {
                var link = $(this);
                var div = link.find('div');
                var title = link.find('p');
                timeline
                    .fromTo(div, 0.5, { y: 100 }, { y: 0, opacity: 1, ease: Power2.easeInOut }, index === 0 ? '0' : '-=0.35')
                    .fromTo(title, 0.5, { y: 100 }, { y: 0, opacity: 1, ease: Power2.easeInOut }, '-=0.45')
            });


            new ScrollMagic.Scene({
                offset: $(this).offset().top / 3,
                reverse: false
            })
                .setTween(timeline)
                .addTo(scrollController);
        });
    }
})();


// solutions overview
(function () {
    var $elements = $('.solutions-overview');
    if ($elements && $elements.length) {
        $elements.each(function () {
            var scrollController = new ScrollMagic.Controller();

            var $element = $(this);
            var contents = $element.find('a');
            var isSmall = window.matchMedia("(max-width: 640px)").matches;
            if (!isSmall) {
                var timeline = new TimelineLite();
                contents.each(function (index) {
                    var content = $(this);
                    var img = content.find('img');
                    var title = content.find('h5');
                    var description = content.find('p');
                    timeline
                        .fromTo(img, 1.25, { scale: 0 }, { scale: 1, autoAlpha: 1, ease: Power4.easeInOut }, index === 0 ? '0' : '-=1')
                        .fromTo(title, 0.5, { y: -100 }, { y: 0, autoAlpha: 1, ease: Power4.easeInOut }, '-=0.8')
                        .fromTo(description, 0.5, { y: -100 }, { y: 0, autoAlpha: 1, ease: Power4.easeInOut }, '-=0.75');
                });

                new ScrollMagic.Scene({
                    offset: ($element.offset().top / 2) + $element.height(),
                    reverse: false
                })
                    .setTween(timeline)
                    .addTo(scrollController);
            } else {
                contents.each(function (index) {
                    var content = $(this);
                    var img = content.find('img');
                    var title = content.find('h5');
                    var description = content.find('p');
                    var timeline = new TimelineLite()
                        .fromTo(img, 1, { scale: 0 }, { scale: 1, autoAlpha: 1, ease: Power4.easeInOut })
                        .fromTo(title, 0.5, { y: -100 }, { y: 0, autoAlpha: 1, ease: Power4.easeInOut }, '-=0.6')
                        .fromTo(description, 0.5, { y: -100 }, { y: 0, autoAlpha: 1, ease: Power4.easeInOut }, '-=0.55');

                    new ScrollMagic.Scene({
                        offset: content.offset().top - ($element.height() / 2) - (content.height() / 2),
                        reverse: false
                    })
                        .setTween(timeline)
                        .addTo(scrollController);
                });
            }
        });
    }
})();

// video banner
(function () {
    var $elements = $('.video-banner');
    if ($elements && $elements.length) {
        $elements.each(function () {
            var $element = $(this);
            var text = $element.find('> .text .rte');
            var video = $element.find('> .video');

            var scrollController = new ScrollMagic.Controller();
            var timeline = new TimelineLite()
                .set(text, { x: -500, opacity: 0 })
                .set(video, { x: 500, opacity: 0 })
                .to(text, 0.5, { x: 0, opacity: 1, ease: Power4.easeInOut })
                .to(video, 0.5, { x: 0, opacity: 1, ease: Power4.easeInOut }, '-=0.5')

            var isLarge = window.matchMedia("(min-width: 1024px)").matches;
            var offset = $element.offset().top - ($element.height() / 2);
            if (!isLarge) {
                offset = $element.offset().top - $element.height();
            }
            new ScrollMagic.Scene({
                offset: offset,
                reverse: false
            })
                .setTween(timeline)
                .addTo(scrollController);
        });

        $(window).on("resize", () => {
            $elements.each(function () {
                var $element = $(this);
                var video = $element.find('.video:visible');
                if (video) {
                    video.attr('style', 'opacity: 1');
                }
            });
        });
    }
})();